import en from "./en.json";
import jaRaw from "./ja.json";

export type Language = "en" | "ja";
export type MessageKey = keyof typeof en;

/**
 * Typing ja as Record<MessageKey, string> makes a missing key a compile error
 * (every en key must exist in ja); extra ja keys are caught by parity.test.ts.
 * This keeps the silent-fallback ban: an absent translation never resolves to
 * English, it surfaces as the raw key string.
 */
const ja: Record<MessageKey, string> = jaRaw;

const dicts: Record<Language, Record<MessageKey, string>> = { en, ja };

let current: Language = "en";

export function setLanguage(lang: Language): void {
  current = lang;
}

export function getLanguage(): Language {
  return current;
}

/**
 * Resolves a message in the current language, interpolating {token} occurrences
 * from params. A missing key returns the key itself (visible bug) rather than
 * falling back to English, so untranslated UI is obvious during review.
 */
export function t(key: MessageKey, params?: Record<string, string | number>): string {
  const raw = dicts[current][key];
  if (raw === undefined) {
    return key;
  }
  if (params === undefined) {
    return raw;
  }
  return raw.replace(/\{(\w+)\}/g, (_match: string, token: string): string => {
    const value = params[token];
    return value === undefined ? `{${token}}` : String(value);
  });
}
